
import { initializeApp } from "firebase/app"
import {
  getAuth,
  PhoneAuthProvider,
  signInWithCredential,
  setPersistence,
  browserLocalPersistence,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  linkWithCredential,
  EmailAuthProvider,
} from "firebase/auth"
import { getDatabase, ref, set, get, onValue, update, remove } from "firebase/database"
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage"

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCP07Au4xZ2NPmcE7T7wJU4wrkqYAmgmUA",
  authDomain: "altrange-dashboard-81282.firebaseapp.com",
  databaseURL: "https://altrange-dashboard-81282-default-rtdb.firebaseio.com",
  projectId: "altrange-dashboard-81282",
  storageBucket: "altrange-dashboard-81282.appspot.com",
  messagingSenderId: "39124649407",
  appId: "1:39124649407:web:fb00003ebccc883d91cd0a",
  measurementId: "G-P6DSBED5R4"
};


const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getDatabase(app)
const storage = getStorage(app)

setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // console.log("Firebase persistence set to LOCAL")
  })
  .catch((error) => {
    console.error("Error setting persistence:", error)
  })

export {
  app,
  firebaseConfig,
  auth,
  db,
  storage,
  PhoneAuthProvider,
  RecaptchaVerifier,
  signInWithCredential,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPhoneNumber,
  setPersistence,
  browserLocalPersistence,
  sendPasswordResetEmail,
  linkWithCredential,
  EmailAuthProvider,
  ref,
  set,
  get,
  onValue,
  update,
  remove,
  storageRef,
  uploadBytes,
  getDownloadURL,
}
